export default "__VITE_ASSET__DAyxB2Jn__"